import { isMeinBuero } from '@/utils/build-env'

const isMeinbuero = isMeinBuero()

const DEFAULT_FOLDERS = {
  INBOX: 'Posteingang',
  BOOKKEEPING: isMeinbuero ? 'WISO MeinBüro Rechnungen' : 'orgaMAX Buchhaltung',
}

export const SYSTEM_FOLDER_NAMES = isMeinbuero
  ? {
    ...DEFAULT_FOLDERS,
    ROOT: 'MeinBüro Portal',
    INVOICES: 'MeinBüro Portal/Rechnungen',
    OFFERS: 'MeinBüro Portal/Angebote',
    ORDERS: 'MeinBüro Portal/Aufträge',
    DOCUMENTS: 'MeinBüro Portal/Dokumente',
  }
  : {
    ...DEFAULT_FOLDERS,
    ROOT: 'shareHUB',
    INVOICES: 'shareHUB/Rechnungen',
    OFFERS: 'shareHUB/Angebote',
    ORDERS: 'shareHUB/Aufträge',
    DOCUMENTS: 'shareHUB/Dokumente',
  }
